(function() {
  var Factory, Router,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Router = App.loadClass('core::Router');

  Factory = App.loadClass('core::Factory');

  exports.RatingsRouter = (function(superClass) {
    extend(RatingsRouter, superClass);

    function RatingsRouter() {
      return RatingsRouter.__super__.constructor.apply(this, arguments);
    }

    RatingsRouter.prototype.prefix = 'Ratings';

    RatingsRouter.prototype.module_name = 'RatingsRouter';

    RatingsRouter.prototype.register = function() {
      this.module = angular.module(this.module_name, ['ui.router', 'ui.bootstrap']);
      this.factory('ratingsFactory', function() {
        return new Factory('portal::Angular/Ratings/Models');
      });
      this.service('portal::Angular/Ratings/Sidebar/SidebarService', ['$http', '$rootScope', 'ratingsFactory']);
      this.controller('portal::Angular/Ratings/Sidebar/SidebarController', ['$scope', '$transitions', 'Ratings.Services.SidebarService', 'Core.Services.Loading', '$q', '$state', '$uibModal']);
      this.controller('portal::Angular/Ratings/Sidebar/SetupTabController', ['$scope', '$transitions', 'Ratings.Services.SidebarService', '$uibModal', '$state']);
      this.controller('portal::Angular/Ratings/Sidebar/RatingsTabController', ['$scope', '$transitions', 'Ratings.Services.SidebarService', '$uibModal', '$state']);
      this.service('portal::Angular/Ratings/Setup/SetupService', ['$http', '$rootScope', 'ratingsFactory']);
      this.controller('portal::Angular/Ratings/Setup/SetupDialogController', ['$scope', '$transitions', '$rootScope', 'Ratings.Services.SetupService', 'Core.Services.Loading', '$q', '$state', 'hooks', '$uibModal']);
      this.controller('portal::Angular/Ratings/Setup/TraitPackageDialogController', ['$scope', '$transitions', 'Ratings.Services.SetupService', '$uibModalInstance', 'lineups_id', 'trait_package', 'trait_suppliers']);
      this.controller('portal::Angular/Ratings/Setup/TreatmentDialogController', ['$scope', '$transitions', 'Ratings.Services.SetupService', '$uibModalInstance', 'lineups_id', 'treatment']);
      this.controller('portal::Angular/Ratings/Setup/AddProductDialogController', ['$scope', '$transitions', 'Ratings.Services.SetupService', '$uibModalInstance', '$timeout', '$q', 'lineups_id']);
      this.controller('portal::Angular/Ratings/Setup/EditProductDialogController', ['$scope', '$transitions', 'Ratings.Services.SetupService', '$uibModalInstance', '$timeout', '$q', 'lineups_id', 'product']);
      this.service('portal::Angular/Ratings/Ratings/RatingsService', ['$http', '$rootScope', 'ratingsFactory']);
      this.controller('portal::Angular/Ratings/Ratings/RatingsDialogController', ['$scope', '$transitions', 'Ratings.Services.RatingsService', 'Core.Services.Loading', '$q', '$state', '$uibModal', '$timeout', '$window']);
      return this.filter('filterInactiveProducts', (function(_this) {
        return function() {
          return function(all_products, show_active_products) {
            if (show_active_products) {
              return all_products;
            } else {
              return _.filter(all_products, {
                active: true
              });
            }
          };
        };
      })(this));
    };

    RatingsRouter.prototype.registerRoutes = function($stateProvider) {
      return $stateProvider.state('portal.ratings', {
        url: '/ratings',
        templateUrl: 'backend/portal/ratings/sidebar',
        controller: 'Ratings.Controllers.SidebarController'
      }).state('portal.ratings.setup', {
        url: '/setup',
        views: {
          'sidebar-tab@portal.ratings': {
            templateUrl: 'backend/portal/ratings/setup-tab',
            controller: 'Ratings.Controllers.SetupTabController'
          }
        }
      }).state('portal.ratings.setup.dialog', {
        url: '/:crop',
        views: {
          'fullpage@portal.ratings': {
            templateUrl: 'backend/portal/ratings/setup/dialog',
            controller: 'Ratings.Controllers.SetupDialogController'
          }
        },
        resolve: {
          'hooks': (function(_this) {
            return function() {
              return {};
            };
          })(this)
        }
      }).state('portal.ratings.ratings', {
        url: '/ratings',
        views: {
          'sidebar-tab@portal.ratings': {
            templateUrl: 'backend/portal/ratings/ratings-tab',
            controller: 'Ratings.Controllers.RatingsTabController'
          }
        }
      }).state('portal.ratings.ratings.dialog', {
        url: '/:crop',
        views: {
          'fullpage@portal.ratings': {
            templateUrl: 'backend/portal/ratings/ratings/dialog',
            controller: 'Ratings.Controllers.RatingsDialogController'
          }
        }
      }).state('portal.ratings.ratings.dialog.add_product', {
        url: '/add-product',
        views: {
          'fullpage2@portal.ratings.ratings.dialog': {
            templateUrl: 'backend/portal/ratings/setup/dialog',
            controller: 'Ratings.Controllers.SetupDialogController'
          }
        },
        resolve: {
          'hooks': [
            '$state', function($state) {
              return {
                afterLoad: (function(_this) {
                  return function(scope) {
                    return scope.addProduct();
                  };
                })(this)
              };
            }
          ]
        }
      });
    };

    return RatingsRouter;

  })(Router);

}).call(this);
